// Переход на оплату по инструкциям, которые вернул сервер (сумму и поля формирует бэкенд).
export function goToPayment(payment) {
  if (!payment) throw new Error('Пустой ответ платёжного сервиса');
  if (payment.mode === 'redirect' && payment.url) {
    window.location.assign(payment.url);
    return;
  }
  if (payment.mode === 'form' && payment.action && payment.fields) {
    const form = document.createElement('form');
    form.action = payment.action;
    form.method = 'post';
    form.acceptCharset = 'utf-8';
    form.style.display = 'none';
    Object.entries(payment.fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return;
  }
  throw new Error('Неизвестный способ оплаты');
}

const locale = (lang) => (lang === 'en' ? 'en-US' : 'ru-RU');

export const formatPrice = (value, lang = 'ru') =>
  `${Number(value).toLocaleString(locale(lang), { maximumFractionDigits: 2 })} ₽`;

const toDate = (iso) => new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`);

export const formatDate = (iso, lang = 'ru') => {
  if (!iso) return '';
  return toDate(iso).toLocaleString(locale(lang), { day: '2-digit', month: 'long', year: 'numeric' });
};

export const formatDateTime = (iso, lang = 'ru') => {
  if (!iso) return '';
  return toDate(iso).toLocaleString(locale(lang), { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/** Склонение по числу. forms: русский — 3 формы [1, 2-4, 5+], английский — 2 формы [one, many]. */
export const plural = (n, forms) => {
  if (forms.length === 2) return n === 1 ? forms[0] : forms[1];
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return forms[0];
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return forms[1];
  return forms[2];
};
